import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  FormControl,
  Input,
  Box,
  Image,
  FormErrorMessage,
  Alert,
  AlertIcon,
  CloseButton,
  AlertDescription,
  Text,
} from '@chakra-ui/react';

import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { forgot } from '../../utils/endpoints';
import { Post } from '../../utils/axiosuitls';

const ForgotPass = () => {
  const formRef = useRef();
  const history = useHistory();

  const [alert, setAlert] = useState({
    type: '',
    msg: '',
    visible: false,
  });

  const initialValues = {
    email: '',
  };
  const validationSchema = Yup.object({
    email: Yup.string().email('Please enter valid email').required('Email address is required'),
  });

  async function onSubmit(values) {
    return Post(forgot, values)
      .then((data) => {
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg: data.data.message,
              type: 'green',
            },
          };
        });
      })
      .catch((error) => {
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg: error.response.data.message,
              type: 'red',
            },
          };
        });
      });
  }

  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      if (e.code === 'Enter') {
        if (formRef.current) {
          formRef.current.handleSubmit();
        }
      }
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setAlert((prevState) => {
        return {
          ...prevState,
          ...{
            visible: false,
          },
        };
      });
    }, 6000);
  }, [alert.visible]);
  const _close = () => {
    setAlert((prevState) => {
      return {
        ...prevState,
        ...{ visible: false },
      };
    });
  };
  return (
    <Box
      w='100vw'
      minH='90vh'
      d='flex'
      justifyContent='center'
      alignItems='center'
      flexDir='column'
      transform='translateY(-50%, -50%)'
    >
      <Box
        d='flex'
        justifyContent='center'
        alignItems='center'
        w={['85%', '80%', '70%', '55%', '35%']}
      >
        {alert.visible && (
          <Alert colorScheme={alert.type} mb='3'>
            <AlertIcon />
            <AlertDescription> {alert.msg} </AlertDescription>
            <CloseButton position='absolute' right='8px' top='8px' onClick={_close} />
          </Alert>
        )}
      </Box>
      <Image src='./images/Logo.svg' width='300px' height='125px' objectFit='contain' />
      <Text
        fontSize={['24px', '28px', '32px', '36px']}
        fontWeight='700'
        style={{ fontFamily: 'Mulish, sans-serif' }}
        color='#222222'
        mb='1rem'
      >
        Forgot Password
      </Text>

      <Box as='span' mb='3' className='forgotText-subheading'>
        Enter your registered email to get recovery instructions
      </Box>
      <Box
        d='flex'
        justifyContent='center'
        alignItems='center'
        w={['85%', '80%', '70%', '55%', '35%']}
      >
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          innerRef={formRef}
        >
          {(props) => (
            <Form
              style={{
                display: 'flex',
                width: '100%',
                flexDirection: 'column',
                padding: '0px 1rem',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                gap: '1rem',
              }}
            >
              <FormControl id='email' isInvalid={props.errors.email && props.touched.email}>
                <Field
                  as={Input}
                  type='email'
                  placeholder='Email address'
                  name='email'
                  autoComplete='off'
                  isInvalid={props.errors.email && props.touched.email}
                  size='lg'
                />
                <FormErrorMessage> {props.errors.email} </FormErrorMessage>
              </FormControl>
              <Button
                type='submit'
                colorScheme='blue'
                size='lg'
                onClick={(e) => {
                  props.handleSubmit(e);
                }}
                tabIndex='3'
                mt={4}
                bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                borderRadius='7px'
                loadingText='Logging In...'
                isLoading={props.isSubmitting}
                fontSize='22px'
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                color='#ffffff'
                w='100%'
                h='50px'
              >
                Reset
              </Button>

              <Box d='flex' justifyContent='center' alignItems='center' w='100%'>
                <Box
                  as='a'
                  style={{ cursor: 'pointer' }}
                  onClick={() => history.push('/login')}
                  className='back-to-login'
                >
                  Back to login
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};
export default ForgotPass;
